import style from "../../templates-modal.module.css";

interface CloseButtonProps {
  onDismiss: () => void;
}

export function CloseButton({ onDismiss }: CloseButtonProps) {
  return (
    <svg
      className={style.closeIcon}
      onClick={onDismiss}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="close-template-modal"
    >
      <path
        d="M6.36407 6.36396L19.092 19.0919M19.092 6.36396L6.36407 19.0919"
        stroke="currentColor"
        strokeWidth="1.74"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
